/**
 * Dogodki v brskalniku, s katerimi se deli vmesnika obvestijo o spremembi
 * podatkov, ki jih hranijo pri sebi.
 *
 * Glavni meni (Glava) hrani seznam podjetij in poročil odprtega podjetja. Po
 * ustvarjanju, preimenovanju, arhiviranju ali izbrisu podjetja, spremembi
 * dodelitve in spremembi paketa ali modulov ju mora prebrati znova, sicer bi
 * kazal zastarel naziv ali zavihke. Dogodek sproži `api` po uspešni
 * spremembi, zato ga posamezna stran ne more pozabiti.
 */
export const SPREMEMBA_PODJETIJ = 'koda:podjetja-spremenjena';

/** Obvesti vse poslušalce, da se je seznam podjetij ali njihovih poročil spremenil. */
export function sporociSpremembaPodjetij(): void {
  window.dispatchEvent(new Event(SPREMEMBA_PODJETIJ));
}
